module.exports = __webpack_public_path__ + "static/media/homepage_tower.1bc83832.png";